import { customDispatch } from "@affinity/Store/ServiceBase";
import { GetQuoteStep } from "@affinity/Store/StoreTypes";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

// External parameters
type HandlerType = Handler<{
    newStep: GetQuoteStep;
}>;

const GetQuoteRevertToStep: HandlerType = ({ dispatch, parameter: { newStep } }) => {
    (dispatch as customDispatch)({
        type: "Affinity/GetQuote/Change",
        newStep
    });
};

const Tracking: HandlerType = props => {
};

const chain = [
    GetQuoteRevertToStep, 
    Tracking
];

const getQuoteRevertToStep = createHandlerChainRunner(chain, "GetQuoteRevertToStep");
export default getQuoteRevertToStep;